module.exports = __webpack_public_path__ + "img/skype.e5f17a88.svg";